import { render, staticRenderFns } from "./Millisecond.vue?vue&type=template&id=2732520b&"
import script from "./Millisecond.vue?vue&type=script&lang=js&"
export * from "./Millisecond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports